/* InstantVacuum — theme behaviour. No dependencies. */
(function () {
  'use strict';

  /* ---------- Sticky header shadow ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Countdown ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(end)) { el.style.display = 'none'; return; }

    var out = el.querySelectorAll('[data-cd]');
    var tick = function () {
      var diff = end - Date.now();
      if (diff <= 0) { el.style.display = 'none'; return; }
      var s = Math.floor(diff / 1000);
      var parts = {
        d: Math.floor(s / 86400),
        h: Math.floor((s % 86400) / 3600),
        m: Math.floor((s % 3600) / 60),
        s: s % 60
      };
      out.forEach(function (node) {
        var v = parts[node.getAttribute('data-cd')];
        node.textContent = v < 10 ? '0' + v : String(v);
      });
    };
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- Sticky buy bar ---------- */
  var bar = document.querySelector('[data-stickybar]');
  var anchor = document.querySelector('[data-stickybar-anchor]');
  if (bar && anchor && 'IntersectionObserver' in window) {
    // Show once the hero CTA has scrolled away, hide again over the buy box.
    var buybox = document.querySelector('[data-buybox]');
    var heroPassed = false, onBuybox = false;
    var sync = function () { bar.classList.toggle('is-visible', heroPassed && !onBuybox); };

    new IntersectionObserver(function (entries) {
      heroPassed = !entries[0].isIntersecting;
      sync();
    }, { rootMargin: '0px' }).observe(anchor);

    if (buybox) {
      new IntersectionObserver(function (entries) {
        onBuybox = entries[0].isIntersecting;
        sync();
      }, { threshold: 0.25 }).observe(buybox);
    }
  }

  /* ---------- Set selector keeps every buy button in sync ---------- */
  var setInputs = document.querySelectorAll('[data-set-input]');
  if (setInputs.length) {
    var applySet = function (input) {
      // Class fallback for browsers without :has()
      setInputs.forEach(function (other) {
        var label = other.closest('.set');
        if (label) label.classList.toggle('is-selected', other === input);
      });
      document.querySelectorAll('[data-variant-field]').forEach(function (f) {
        f.value = input.value;
      });
      document.querySelectorAll('[data-qty-field]').forEach(function (f) {
        f.value = input.getAttribute('data-qty') || '1';
      });
      document.querySelectorAll('[data-live-price]').forEach(function (n) {
        n.textContent = input.getAttribute('data-price') || n.textContent;
      });
      document.querySelectorAll('[data-live-compare]').forEach(function (n) {
        var c = input.getAttribute('data-compare');
        n.textContent = c || '';
        n.style.display = c ? '' : 'none';
      });
    };
    setInputs.forEach(function (i) {
      i.addEventListener('change', function () { applySet(i); });
      if (i.checked) applySet(i);
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var revealables = document.querySelectorAll('.reveal');
  if (revealables.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealables.forEach(function (el) { io.observe(el); });
  } else {
    revealables.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Cart count refresh after add-to-cart ---------- */
  document.querySelectorAll('[data-add-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('[type=submit]');
      if (btn) { btn.setAttribute('disabled', 'disabled'); btn.textContent = 'Einen Moment …'; }
    });
  });
})();



/* ---------- Mobile navigation ---------- */
(function () {
  var toggle = document.querySelector('[data-mobile-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (!toggle || !menu) return;

  var closeMenu = function () {
    toggle.setAttribute('aria-expanded', 'false');
    menu.hidden = true;
  };

  toggle.addEventListener('click', function () {
    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    menu.hidden = isOpen;
  });

  menu.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });
})();

/* ---------- Legal / contact dialogs ---------- */
(function () {
  var openers = document.querySelectorAll('[data-legal-dialog-open]');
  var closeDialog = function (dialog) {
    if (dialog && dialog.open) dialog.close();
    document.body.classList.remove('legal-dialog-open');
    if (window.location.hash && document.getElementById(window.location.hash.slice(1)) && document.getElementById(window.location.hash.slice(1)).classList.contains('legal-dialog')) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  };

  var openDialog = function (id) {
    var dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function') return;
    if (!dialog.open) dialog.showModal();
    document.body.classList.add('legal-dialog-open');
  };

  openers.forEach(function (link) {
    link.addEventListener('click', function (e) {
      var id = link.getAttribute('data-legal-dialog-open');
      if (!document.getElementById(id)) return;
      e.preventDefault();
      history.replaceState(null, '', '#' + id);
      openDialog(id);
    });
  });

  document.querySelectorAll('.legal-dialog').forEach(function (dialog) {
    dialog.querySelectorAll('[data-legal-dialog-close]').forEach(function (button) {
      button.addEventListener('click', function () { closeDialog(dialog); });
    });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeDialog(dialog);
    });
    dialog.addEventListener('close', function () {
      document.body.classList.remove('legal-dialog-open');
    });
  });

  if (window.location.hash) {
    var hashDialog = window.location.hash.slice(1);
    if (document.getElementById(hashDialog) && document.getElementById(hashDialog).classList.contains('legal-dialog')) openDialog(hashDialog);
  }
  var auto = document.querySelector('[data-legal-dialog-auto]');
  if (auto) openDialog(auto.getAttribute('data-legal-dialog-auto'));
})();

/* ---------- Safe homepage anchor navigation ---------- */
(function () {
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href^="#"]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || href === '#') return;
    var id = href.slice(1);
    if (document.getElementById(id)) return;
    // Legal dialogs are rendered globally; missing targets here are landing-page sections.
    var root = document.documentElement.getAttribute('data-root-url') || '/';
    e.preventDefault();
    window.location.href = root + href;
  });
})();


/* Mobile visibility safety — does not replace or rewrite image sources. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(max-width: 899px)').matches) return;
  document.querySelectorAll('.reveal').forEach(function (el) {
    el.classList.add('is-in');
  });
  document.querySelectorAll('.hero__media img, .acc__media img, .gallery__item img, .pdp__media img').forEach(function (img) {
    img.style.opacity = '1';
    img.style.visibility = 'visible';
  });
})();
